export default __webpack_public_path__ + "static/media/fun_jul2020_pt2.0cec40ac.bmp";